import { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Link, useParams } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import {
	ArrowBack,
	CheckCircleOutlined,
	PlaceOutlined,
	Schedule,
	VisibilityOutlined,
} from '@mui/icons-material';
import { 	Accessories,
	ButtonContainer,
	CarData,
	Card,
	CardsContainer,
	Container,
	CopiaECola,
	DescriptionContainer,
	ExternalLink,
	FlexDiv,
	Logo,
	MainTitle,
	OrangeText,
	PixContainer,
	PixCopyPasteConfirm,
	PixInstruction,
	Text,
	Title} from '../details/Details.styles';
import {
	Button,
	CarInfo,
	SpotlightCarousel,
	IconInfo,
	Modal,
	Input,
	Loading,
	ErrorScreen,
} from '../../components';
import {
	TAnuncioPagamento,
	getOfferById,
	postOfferProposal,
	postOfferPayment,
  TAnuncioHistorico,
} from '../../services/offer';
import { TAnuncio, TConcessionaria, TGrupoConcessionaria } from '../../services';
import {
	CarDetail,
	StatusLabel,
	StatusOffer,
	TagStatus,
	UserRole,
	dateTimeFormatter,
	findBestOffer,
	getImageUrl,
	allowedTimeToBuyStart,
	allowedTimeToBuyEnd,
	moneyFormatter,
	minimumIncrementOffer,
	TagStatusLabel,
	offerPrice,
	offerPriceMotorcycle,
	offerPriceBus,
} from '../../utils';
import { defineOfferStatus } from '../../utils/methods/defineOfferStatus';
import { addressFormatter } from '../../utils/methods/addressFormatter';
import { useToastStore, useUserStore } from '../../stores';
import { postCreateOfferPayment } from '../../services/offer/postCreateOfferPayment';
import { getFipeByCodigoFipe } from '../../services/offer/getFipeVehicle';
import BuyNowModal from '../../components/CompraOuPropostaModal/BuyNowModal';
import PropostaModal from '../../components/CompraOuPropostaModal/PropostaModal';
import ListTableLance from '../../components/table-visible-lance';
import { useListViewLance } from '../../utils/hooks/useListLanceUser';
import { useRecaptcha } from '../../utils/hooks/useRecaptcha';

import RecaptModal from '../../components/recaptcha';
import { CompreAgoraTable } from '../../components/compreAgoratable';
import { useListView } from '../../utils/hooks/useModalListUsesView';
import { getOfferStory } from '../../services/offer/getOfferStory';


const PageViewScreen: FC = () => {
const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const [pagesData, setPagesData] = useState<TAnuncioHistorico[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { setToast } = useToastStore();

  const fetchOfferStory = useCallback(async () => {
    try {
		if (!id) {
      throw new Error('ID não encontrado na URL');
    }
      setIsLoading(true);
      const result = await getOfferStory(id);
      if(!result?.success) {
		setToast({message: result.message, variant:"error"});
		return;
	  }
      setPagesData(result.data);
    } catch (error) {
      console.error(error);
      setError(error instanceof Error ? error.message : 'Erro desconhecido');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOfferStory();
  }, [fetchOfferStory]);

  const nextPage = () => {
    setCurrentPage((prev) => (prev + 1) % pagesData.length);
  };

  const prevPage = () => {
    setCurrentPage((prev) => (prev - 1 + pagesData.length) % pagesData.length);
  };

  if (isLoading) {
    return <div className="flex justify-center items-center min-h-screen">Carregando...</div>;
  }

  if (error) {
    return <div className="flex justify-center items-center min-h-screen text-red-500">{error}</div>;
  }

  if (pagesData.length === 0) {
    return <div className="flex justify-center items-center min-h-screen">Nenhum dado disponível</div>;
  }

 
  

return (
		<Container>
			<Link to='/anuncios'>
				<Button variant='text'>
					<ArrowBack fontSize='inherit' />
					<span>Voltar para os anúncios</span>
				</Button>
			</Link>
			 {/* Controles de navegação */}
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      margin: '1rem 0'
    }}>
      <IconButton 
        onClick={prevPage}
        disabled={pagesData.length <= 1}
        aria-label="Página anterior"
      >
        <ChevronLeft fontSize='large' />
      </IconButton>
      
      <Typography variant='subtitle1'>
        Página {currentPage + 1} de {pagesData.length}
      </Typography>
      
      <IconButton 
        onClick={nextPage}
        disabled={pagesData.length <= 1}
        aria-label="Próxima página"
      >
        <ChevronRight fontSize='large' />
      </IconButton>
    </div>
			<CardsContainer>
				<div>
          <Card>
                      <MainTitle>{pagesData[currentPage].veiculos[0].modelo }</MainTitle>
                      <FlexDiv $alignItemsMobile='start'>
                        <IconInfo
                          variant='large'
                          icon={<Schedule fontSize='inherit' />}
                         title={dateTimeFormatter(pagesData[currentPage].data_ocorrencia || '')}
                        />
                        <IconInfo
                          variant='large'
                          icon={<VisibilityOutlined fontSize='inherit' />}
                          title={`Visualizações: ${pagesData[currentPage].qtd_total_click || 'sem informação'}`}
                        />
                      </FlexDiv>
                    <SpotlightCarousel
                    images={[]}/>
                    </Card>
					<Card>
						{pagesData[currentPage].texto_padrao && (
							<DescriptionContainer>
								<Title>Informações do Anúncio</Title>
								<Text>'{pagesData[currentPage]!.texto_padrao}'</Text>
							</DescriptionContainer>
						)}
						{pagesData[currentPage].veiculos[0] && (
							<DescriptionContainer>
								<Title>Observações</Title>
								<Text>{pagesData[currentPage].veiculos[0].observacao}</Text>
							</DescriptionContainer>
						)}
						{pagesData[currentPage].veiculos[0].avarias && (
							<DescriptionContainer>
								<Title>Avarias</Title>
								<Text>{pagesData[currentPage].veiculos[0].avarias}</Text>
							</DescriptionContainer>
						)}
						<Title>Acessórios</Title>
						{/* {pagesData[currentPage].veiculO_ACESSORIOS?.length ? (
							<Accessories>
								{pagesData[currentPage].veiculO_ACESSORIOS?.map((acessorio) => (
									<IconInfo
										key={acessorio.nuM_ID_ACESSORIO}
										value={acessorio.deS_ACESSORIO?.toUpperCase()}
										icon={<CheckCircleOutlined fontSize='inherit' />}
									/>
								))}
							</Accessories>
						) : (
							<Text>Nenhum acessório disponível</Text>
						)} */}
						<Title>Laudo Técnico</Title>
						{pagesData[currentPage].veiculos[0].laudo ? (
							<ExternalLink
								href={getImageUrl.laudoTecnico(pagesData[currentPage].id_anuncio!, pagesData[currentPage].veiculos[0].laudo ?? "")}
								target='_blank'
							>
								Clique aqui
							</ExternalLink>
						) : (
							<Text>Nenhum laudo técnico disponível</Text>
						)}
					</Card>
				</div>
				<div>
					<Card>
						<Title>Dados do Veículo</Title>
						<CarData>
							<CarInfo
								variant='large'
								category={CarDetail.Plate}
								value={pagesData[currentPage].veiculos[0].placa || 'Sem informação'}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.Engine}
								value={pagesData[currentPage].veiculos[0].motor || 'Sem informação'}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.DistanceTraveled}
								value={String(pagesData[currentPage].veiculos[0].km) || 'Sem informação'}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.Transmission}
								value={pagesData[currentPage].veiculos[0].transmissao || 'Sem informação'}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.Year}
								value={`${pagesData[currentPage].veiculos[0].ano_fabricacao}/${pagesData[currentPage].veiculos[0].ano_modelo}`}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.Fuel}
								value={pagesData[currentPage].veiculos[0].combustivel || 'Sem informação'}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.Color}
								value={pagesData[currentPage].veiculos[0].cor || 'Sem informação'}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.Doors}
								value={String(pagesData[currentPage].veiculos[0].portas) || 'Sem informação'}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.FipeCode}
								value={pagesData[currentPage].veiculos[0].codigo_fipe || 'Sem informação'}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.ValorInicial}
								value={pagesData[currentPage].val_inicial!.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
							/>
							<CarInfo
								variant='large'
								category={CarDetail.ValorCompreAgora}
								value={pagesData[currentPage].val_compre_agora!.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
							/>
						</CarData>
					</Card>
					
				</div>
			</CardsContainer>
		</Container>
	);
};

export default PageViewScreen;
